import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { HomeownershipEducationStepComponent } from "../../wizard/wizard-steps/homeownership-education-step/homeownership-education-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class HomeownershipEducationStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = HomeownershipEducationStepComponent;
  }
}
